module.exports = __webpack_public_path__ + "img/inthecafe.24990e1a.jpg";